<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    persistent
    v-bind:style="{ zIndex: options.zIndex }"
  >
    <v-card class="confirm-box custom-shadow rounded-lg">
      <v-card-title
        class="font-weight-medium white--text"
        :class="[{ headline: isMobile }, options.color]"
      >
        {{ title }}
      </v-card-title>
      <v-card-text
        class="pt-4"
        v-show="!!message"
        v-html="message"
      ></v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click.native="cancel" v-if="!onlyConfirm">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          :color="options.color"
          depressed
          @click.native="agree"
          class="custom-shadow rounded-lg"
        >
          {{ onlyConfirm ? "OK" : $t("confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    onlyConfirm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      color: "error",
      width: 400,
      zIndex: 200,
    },
  }),
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.reject(false);
      this.dialog = false;
    },
  },
  computed: {
    isMobile() {
      return false;
    },
  },
};
</script>

<style>
.confirm-box .v-card__text {
  color: rgba(0, 0, 0, 0.9) !important;
  padding: 16px !important;
}
</style>
